import React from "react";
import Slider from "react-slick";
import FirstScreenBG from "../../img/wab_first_screen.jpg";
import SliderName from "../../img/slider-name-tiian.png"

function FirstScreenSpeacers({slider_data}) {

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: 1
    };

    return (
        slider_data ?
            <div className="relative">
                <div className="gallery">
                    <div className="slider-container">
                        <Slider {...settings}>
                            {
                                slider_data.map((item, value) => (
                                    <>
                                        {item.acf.big_image ?
                                            <div className="relative" key={value}>
                                                <img src={item.acf.big_image} alt={item.acf.speacer_name}
                                                     className="relative bottom-[50px] pt-[50px] left-0 right-0 m-auto z-10 !w-auto h-[100%] max-h-[400px] sm:max-h-[510px] lg:max-h-[520px] 2xl:max-h-[580px]"/>
                                                <div
                                                    className="z-20 absolute bottom-1 right-0 grid grid-cols-4 sm:w-[90%] w-[100%] justify-center items-stretch flex-wrap">

                                                    {item.acf.logo ?
                                                        <div
                                                            className="h-full p-2 flex justify-center items-center z-30 bg-white col-span-1">
                                                            <img src={item.acf.logo} alt="logo"
                                                                 className="max-h-[50px] mx-auto"/>
                                                        </div> : ''
                                                    }
                                                    {/*<div className="slider-triangle"/>*/}
                                                    <div
                                                        className="z-20 h-full col-span-3">
                                                        <h3 className="text-white py-1 px-3" style={{
                                                            background: 'url(' + SliderName + ')',
                                                            backgroundSize: 'cover',
                                                            backgroundRepeat: 'no-repeat',
                                                            backgroundPosition: 'top right',
                                                        }}>
                                                            {item.post_title}
                                                        </h3>
                                                        <p className="max-sm:leading-tight text-white max-sm:text-[13px] py-1 px-3 bg-[#5667FF]">{item.acf.position_short ? item.acf.position_short : item.acf.position}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            : ''}
                                    </>
                                ))
                            }
                        </Slider>
                    </div>
                </div>
            </div>
            : ''
    )
}

export default FirstScreenSpeacers;